import { axiosClient } from "./axiosClient"

export const OUTSOURCER_PATH = '/api/v1/outsourcer'

export const addOutsourcer = (body) => {
    return axiosClient.post(OUTSOURCER_PATH, body)
}

export const updateOutsourcer = (id, body) => {
    return axiosClient.put(`${OUTSOURCER_PATH}/${id}`, body)
}

export const deleteOutsourcer = (id) => {
    return axiosClient.delete(`${OUTSOURCER_PATH}/${id}`)
}

export const getOutsourcerById = (id) => {
    return axiosClient.get(`${OUTSOURCER_PATH}/${id}`)
}

export const getPageOutsourcers = ({ search = "", lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${OUTSOURCER_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}

export const uploadOutsourcerExcelFile = (body) => {
    return axiosClient.post(`${OUTSOURCER_PATH}/upload-excel`, body)
}

export const downloadOutsourcerExcelFile = () => {
    return axiosClient.get(`${OUTSOURCER_PATH}/download-excel`, {
        responseType: 'arraybuffer',
    })
}

export const downloadOutsourcerReceipt = (id, firstDate, lastDate) => {
    return axiosClient.get(`${OUTSOURCER_PATH}/receipt/${id}?firstDate=${firstDate}&lastDate=${lastDate}`, {
        responseType: 'arraybuffer',
    })
}

export const downloadOutsourcerReceipts = (currency) => {
    return axiosClient.get(`${OUTSOURCER_PATH}/receipts?currency=${currency}`, {
        responseType: 'arraybuffer',
    })
}
